import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN_RECEPTION;
const environment = import.meta.env.VITE_APP_STAGE || undefined;
const forceEnable = import.meta.env.VITE_SENTRY_FORCE_ENABLE === "true";
const isLocalOrDev = environment === "local" || environment === "dev";

if (dsn && (forceEnable || !isLocalOrDev)) {
  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*\.execute-api\.ap-northeast-1\.amazonaws\.com/,
    ],
    tracesSampleRate: environment === "prd" ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.user) {
        const { ip_address: _, ...userWithoutIp } = event.user;
        return { ...event, user: userWithoutIp };
      }
      return event;
    },
  });
}
